import React, { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = `Project Enquiry from ${formData.name}`;
    const body = `Name: ${formData.name}\nEmail: ${formData.email}\nCompany: ${formData.company}\n\nProject Details:\n${formData.message}`;
    window.location.href = `mailto:hello@planapplysystems.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setFormData({ name: '', email: '', company: '', message: '' });
  };

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-pas-forest mb-4">Let's Work Together</h2>
            <p className="text-xl text-gray-600">
              Partner with us to streamline your processes, improve efficiency, and embrace the future of automation.
            </p>
            <p className="text-gray-600 mt-3">
              Contact us today to discuss your project needs.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6 mb-12">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-semibold text-pas-forest mb-2">Full Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-pas-leaf focus:ring-2 focus:ring-[#c5eea0] transition"
                  placeholder="Your name"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-pas-forest mb-2">Email Address *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-pas-leaf focus:ring-2 focus:ring-[#c5eea0] transition"
                  placeholder="your@email.com"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-pas-forest mb-2">Company Name</label>
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-pas-leaf focus:ring-2 focus:ring-[#c5eea0] transition"
                placeholder="Your company"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-pas-forest mb-2">Project Requirements *</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-pas-leaf focus:ring-2 focus:ring-[#c5eea0] transition resize-none"
                placeholder="Tell us about your process, automation, or validation project..."
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full px-8 py-3 bg-pas-lime text-pas-forest font-semibold rounded-lg hover:brightness-110 transition transform hover:scale-105"
            >
              Contact Us Today
            </button>
          </form>

          <div className="border-t border-gray-200 pt-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div className="text-center">
                <div className="text-3xl mb-2">📧</div>
                <h3 className="font-semibold text-pas-forest mb-1">Email</h3>
                <a href="mailto:hello@planapplysystems.com" className="text-pas-leaf hover:text-pas-forest">
                  hello@planapplysystems.com
                </a>
              </div>
              <div className="text-center">
                <div className="text-3xl mb-2">🌍</div>
                <h3 className="font-semibold text-pas-forest mb-1">Industries Supported</h3>
                <p className="text-gray-600">Pharmaceuticals, Oil & Gas, Manufacturing</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
